import { SVGProps } from "react"
const FormFailNewIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="66"
    height="66"
    viewBox="0 0 66 66"
    fill="none"
    {...props}
  >
    <path
      d="M33 60.5C48.125 60.5 60.5 48.125 60.5 33C60.5 17.875 48.125 5.5 33 5.5C17.875 5.5 5.5 17.875 5.5 33C5.5 48.125 17.875 60.5 33 60.5Z"
      stroke={props.color || "#C41407"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.2175 40.7823L40.7825 25.2173"
      stroke={props.color || "#C41407"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.7825 40.7823L25.2175 25.2173"
      stroke={props.color || "#C41407"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default FormFailNewIcon
